import { createReducer, on } from '@ngrx/store';
import { ActionStateCreator, IActionState } from '@resident-nx/shared';
import {
  LoadFederatedLoginWeb,
  LoadFederatedLoginWebFail,
  LoadFederatedLoginWebSuccess,
} from './auth.actions';

export interface IAuthState {
  federatedLoginDataActionState: IActionState;
}

const initialState: IAuthState = {
  federatedLoginDataActionState: ActionStateCreator.create(),
};

export const authReducer = createReducer(
  initialState,

  on(LoadFederatedLoginWeb, state => {
    return {
      ...state,
      federatedLoginDataActionState: ActionStateCreator.onStart(),
    };
  }),

  on(LoadFederatedLoginWebSuccess, state => {
    return {
      ...state,
      federatedLoginDataActionState: ActionStateCreator.onSuccess(),
    };
  }),

  on(LoadFederatedLoginWebFail, (state, { error }) => {
    return {
      ...state,
      federatedLoginDataActionState: ActionStateCreator.onError(error),
    };
  })
);
